import { useEffect, useRef, useState } from "react";

/**
 * Прячет хедер при скролле вниз и показывает при скролле вверх.
 * - threshold: после какого смещения начинаем прятать (в px)
 * - delta: минимальная разница скролла, чтобы реагировать (в px)
 */
export function useScrollHide(threshold = 24, delta = 6) {
    const [hidden, setHidden] = useState(false);

    const lastY = useRef<number>(0);
    const ticking = useRef(false);
    const started = useRef(false);

    useEffect(() => {
        const onScroll = () => {
            if (ticking.current) return;
            ticking.current = true;

            requestAnimationFrame(() => {
                const y = window.scrollY || window.pageYOffset || 0;

                if (!started.current) {
                    started.current = true;
                    lastY.current = y;
                    ticking.current = false;
                    return;
                }

                const diff = y - lastY.current;

                if (y <= threshold) {
                    setHidden(false);
                    lastY.current = y;
                    ticking.current = false;
                    return;
                }

                if (Math.abs(diff) < delta) {
                    ticking.current = false;
                    return;
                }

                setHidden(diff > 0);

                lastY.current = y;
                ticking.current = false;
            });
        };

        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, [threshold, delta]);

    return hidden;
}
